<!-- * @author Ketan Shetye -->
<!-- * @created 2025-10-09 -->
<!-- * @description applicant home component html file -->

<!-- main container -->
<div class="main-container">
  @if (applicantHomeDetails.primaryDrawerItems.length > 0) {
  <!-- header parent container -->
  <div class="header-parent-container">
    <!-- header container -->
    <div class="header-container">
      <!-- seal img -->
      <!-- Start code edited by Sanchit on 06-03-2026 -->
      <!-- @if (context.client?.logoURL) {
      <img [src]="context.client?.logoURL" alt="Seal" class="seal" (click)="goHome()"/>
      }@else {
        <img src="favicon.ico" alt="Seal" class="seal" (click)="goHome()"/>
      } -->
      <!-- Start code added by Sanchit on 03/18/2026 -->
      @if (context.client) {
      <div
        class="logo-wrapper"
        tabindex="0"
        (click)="goHome()"
        (keydown.enter)="goHome()"
        (keydown.space)="goHome()"
      >
        <!-- <div class="logo-loader" *ngIf="isLogoLoading"></div> -->
        @if (isLogoLoading) {
        <!-- <div class="center-loader"></div> -->
        <div class="logo-loader">
          <mat-progress-spinner mode="indeterminate" diameter="40">
          </mat-progress-spinner>
        </div>
        }
        <img
          [src]="
            context.client?.logoURL ||
            'assets/images/placeholder-logo/placeholder-logo.png'
          "
          alt="Seal"
          class="seal"
          (click)="goHome()"
          (load)="onLogoLoad()"
          (error)="onLogoError($event)"
          [style.visibility]="isLogoLoading ? 'hidden' : 'visible'"
        />
      </div>
      }
      <!-- End code added by Sanchit on 03/18/2026 -->
      <!-- End code edited by Sanchit on 06-03-2026 -->
      <!-- town typo -->
      <!-- @if (clients.length > 1) { -->
       @if (context.user && clients.length > 1) {

      <div
        class="jurisdiction-container clickable"
        tabindex="0"
        [matMenuTriggerFor]="jurisdictionSwitcherMenu"
        (menuOpened)="onJurisdictionMenuOpened()"
        (menuClosed)="onJurisdictionMenuClosed()"
      >
        <wm-common-text
          [data]="{ text: context.client?.name, textTransform: 'camelcase' }"
        ></wm-common-text>
        <wm-common-icon
          [data]="{ iconName: applicantHomeAssets.keyBoardDropDownIcon }"
        ></wm-common-icon>
      </div>
      }@else {
      <div class="jurisdiction-container">
        <wm-common-text
          [data]="{ text: context.client?.name }"
        ></wm-common-text>
      </div>
      }

      <!-- added by priya 21-01-2026 -->

      <mat-menu
        #jurisdictionSwitcherMenu="matMenu"
        class="jurisdiction-menu-panel"
        xPosition="after"
        yPosition="below"
      >
        <div
          class="jurisdiction-switcher-menu-card"
          [ngClass]="{
            'scrollable-jurisdiction-switcher-menu-card': clients.length > 5
          }"
        >
          @if (jurisdictionsFetchError) {
          <wm-common-text [data]="{ text: jurisdictionsFetchError }"></wm-common-text>
          }@else { @if (jurisdictionsFetching === false) {@if(clients.length > 4){
            <div (click)="$event.stopPropagation()">
              <!-- Added by amisha on 2026-05-25 to isolate the applicant jurisdiction search styling
                   from global filter-builder `.search-content` rules that load on My Applications.
                   Reason: the shared class name was restyling this menu differently across applicant routes. -->
              <div class="jurisdiction-search-content">
              <wm-common-textfield class="jurisdiction-search-field" [data]="jurisdictionSearchFieldConfig" [(ngModel)]="jurisdictionSearchQuery"
                (ngModelChange)="handleJurisdictionSearchChange($event)">
              </wm-common-textfield>
            </div>
            </div>
            } @for (jurisdiction of
          displayJurisdictions; track $index) {
          <div [ngClass]="{ 'active-jurisdiction': jurisdiction.id === clientId }">
            <wm-common-button [data]="onClientMenuItemClick(jurisdiction)"></wm-common-button>
          </div>
          }}@else {
          <mat-progress-spinner mode="indeterminate" diameter="48">
          </mat-progress-spinner>
          } }
        </div>
      </mat-menu>
      <!-- end by priya 21-01-2026 -->

      <!-- profile container -->

      <ng-template #profileButtonTemplate>
        <div class="profile-container">
          <!-- profile name typo -->
          <div class="profile-name-typo">
            <wm-common-text
              [data]="{ text: context.user?.name }"
            ></wm-common-text>
          </div>
          <!-- profile pic -->
          <!-- added by priya 21-01-2026 -->

          @if (context?.user?.userName) {
          <div class="profile-pic-frame">
            <img
              [src]="
                context?.user?.userProfileImageURL ||
                applicantHomeAssets?.profilePic
              "
              alt="Profile Pic"
              class="profile-pic"
            />
          </div>
          }

          <!-- end by priya 21-01-2026 -->
        </div>
      </ng-template>

      <!-- profile button wrapper (positions menu relative to button) -->
      @if(!context.isLoggedIn || !context.user){
      <div class="auth-container">
        <div
          class="auth-button"
          matTooltip="Login"
          matTooltipPosition="below"
          (click)="onLoginClick()"
        >
          <wm-common-icon [data]="{ iconName: 'login' }"></wm-common-icon>
          <div class="auth-text">
            <wm-common-text [data]="{ text: 'LOGIN' }"></wm-common-text>
          </div>
        </div>
        <div
          class="auth-button"
          matTooltip="Sign Up"
          matTooltipPosition="below"
          (click)="onSignUpClick()"
        >
          <wm-common-icon [data]="{ iconName: 'person_add' }"></wm-common-icon>
          <div class="auth-text">
            <wm-common-text [data]="{ text: 'SIGN-UP' }"></wm-common-text>
          </div>
        </div>
      </div>
      }@else{
      <!-- Added by amisha on 2026-05-11.
             Reason: use a Material overlay trigger so the applicant profile menu can render above the mobile chat layer. -->
      <div
        #profileBtnWrap
        class="profile-button-wrapper"
        [matMenuTriggerFor]="profileMenuMatMenu"
        #profileMenuTrigger="matMenuTrigger"
        (menuOpened)="onApplicantProfileMenuOpened()"
        (menuClosed)="onApplicantProfileMenuClosed()"
        (click)="$event.stopPropagation()"
      >
        <wm-common-button
          [data]="{ text: profileButtonTemplate }"
        ></wm-common-button>
      </div>

      <!-- Added by amisha on 2026-05-11.
             Reason: move the profile actions into a real overlay menu instead of the old in-page dropdown. -->
      <mat-menu
        #profileMenuMatMenu="matMenu"
        class="applicant-profile-menu-panel"
        xPosition="before"
        yPosition="below"
        [overlapTrigger]="false"
      >
        <div
          class="profile-menu"
          role="menu"
          aria-label="Profile menu"
          (click)="$event.stopPropagation()"
        >
          <!-- List (left aligned icons + labels) -->
          <div class="profile-menu-list">
            <!-- Edit Profile -->
            <ng-template #tplEditProfile>
              <div class="menu-item">
                <wm-common-icon
                  [data]="{
                    iconName: 'account_circle',
                    iconSet: 'material-icons-outlined'
                  }"
                ></wm-common-icon>
                <span class="menu-label">Edit Profile</span>
              </div>
            </ng-template>
            <wm-common-button
              class="menu-item-btn"
              [data]="{ text: tplEditProfile, onClick: goToEditProfile }"
            ></wm-common-button>

            <!-- Change password -->
            <ng-template #tplChangePassword>
              <div class="menu-item">
                <wm-common-icon
                  [data]="{ iconName: 'password' }"
                ></wm-common-icon>
                <span class="menu-label">Change password</span>
              </div>
            </ng-template>
            <wm-common-button
              class="menu-item-btn"
              [data]="{ text: tplChangePassword, onClick: goToChangePassword }"
            ></wm-common-button>

            <!-- Logout -->
            <ng-template #tplLogout>
              <div class="menu-item">
                <wm-common-icon
                  [data]="{ iconName: 'logout' }"
                ></wm-common-icon>
                <span class="menu-label">Logout</span>
              </div>
            </ng-template>
            <wm-common-button
              class="menu-item-btn logout"
              [data]="{ text: tplLogout, onClick: onSignOutClick }"
            ></wm-common-button>
          </div>
        </div>
      </mat-menu>
      }
      <!-- end profile wrapper -->
    </div>
  </div>

  <!-- body parent container -->
  <div class="body-parent-container">
    <!-- body container -->
    <div class="body-container">
      <!-- primary drawer container -->

      <div class="primary-drawer-container" *ngIf="!hideSidebar">
        <button
          *ngIf="canScrollMenuLeft"
          type="button"
          class="menu-scroll-button menu-scroll-button-left"
          aria-label="Scroll menu left"
          (click)="scrollMenu('left')"
        >
          <wm-common-icon [data]="{ iconName: 'chevron_left' }"></wm-common-icon>
        </button>

        <!--   added by priya 2025-11-12-->
        <div
          #primaryDrawerMenu
          class="primary-drawer-inner-content"
          (scroll)="updateMenuScrollButtons()"
        >
          <div *ngIf="showHamburger">
            <wm-common-icon
              class="menu-icon"
              [data]="{ iconName: applicantHomeAssets.hamburgerIcon }"
              (click)="toggleStepper()"
            ></wm-common-icon>
          </div>

          <!--   end by priya 2025-11-12-->
          <!-- primary drawer button -->
          <div
            *ngFor="
              let item of applicantHomeDetails.primaryDrawerItems;
              let i = index;
              trackBy: trackByIndex
            "
            class="primary-drawer-button"
            [ngClass]="{
              'active-primary-drawer-button': isPrimaryDrawerItemActive(
                item.navigateTo
              )
            }"
          >
            <ng-template #primaryDrawerButtonTemplate>
              <div class="drawer-item">
                <div class="laptop-view-label">
                  <wm-common-text
                    [data]="{ text: item.laptopDisplay }"
                  ></wm-common-text>
                </div>

                <div
                  class="mobile-view-label"
                  [ngClass]="{
                    'active-mobile-view-label': isPrimaryDrawerItemActive(
                      item.navigateTo
                    )
                  }"
                >
                  <wm-common-text
                    [data]="{ text: item.mobileDisplay }"
                  ></wm-common-text>
                </div>
                @if (item.navigateTo === 'my-applications') {
                <div class="notification-wrapper" style="padding-right: 5px;">
                  <wm-common-icon
                    [data]="{ iconName: 'notifications' }"
                    class="bell-icon"
                  ></wm-common-icon>

                  <!-- Red dot -->
                  <span *ngIf="hasAlerts" class="notification-dot"></span>
                </div>
                }
              </div>
            </ng-template>
            <wm-common-button
              [data]="
                getPrimaryDrawerButtonData(i, primaryDrawerButtonTemplate)
              "
            ></wm-common-button>
          </div>
          <!-- added by priya 2025-11-12 -->
        </div>
        <!-- end by priya 2025-11-12 -->

        <button
          *ngIf="canScrollMenuRight"
          type="button"
          class="menu-scroll-button menu-scroll-button-right"
          aria-label="Scroll menu right"
          (click)="scrollMenu('right')"
        >
          <wm-common-icon [data]="{ iconName: 'chevron_right' }"></wm-common-icon>
        </button>
      </div>

      <!-- main body container -->
      <div class="main-body-container">
        <div class="route-body">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
  }@else {
  <div
    style="display: flex;justify-content: center;align-items: center;height: 100%;"
  >
    <mat-progress-spinner mode="indeterminate" diameter="48">
    </mat-progress-spinner>
  </div>
  }
</div>
<!-- sign out modal -->
<wm-common-confirmation-modal
  [data]="signOutModalData"
  (onYesClick)="handleSignOutModalAccepted()"
  (onNoClick)="handleSignOutModalModalRejected()"
>
</wm-common-confirmation-modal>
